// import hidePasswordIcon from 'assets/images/hidePasswordIcon.png';
// import showPasswordIcon from 'assets/images/showPasswordIcon.png';
import React from 'react';
// import CustomTooltip from './CustomTooltip';
import { Error, InputForm, InputMask, Title } from './styles';

interface InputProps {
  title?: string;
  name?: string;
  id?: string;
  autoComplete?: string;
  className?: any;
  typeInput?: string;
  style?: any;
  styleTitle?: any;
  disabled?: boolean;
  onChange: (value: any) => void;
  onBlur?: () => void;
  mask?: any;
  messageTooltip?: JSX.Element;
  isTooltip?: boolean;
  placeholder: string;
  type?: any;
  touched?: any;
  error?: any;
  value?: any;
  isRequired?: boolean;
  maxLength?: number;
  step?: string | number;
}

const InputCustom: React.FC<InputProps> = (
  {
    title,
    type,
    mask,
    touched,
    style,
    error,
    placeholder,
    autoComplete,
    onChange,
    onBlur,
    typeInput,
    styleTitle,
    value,
    id,
    disabled,
    isRequired,
    maxLength,
    step,
  }: InputProps,
  ...rest
) => {
  const Input =
    typeInput === 'mask' ? InputMask : (InputForm as React.ElementType);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value.toUpperCase());
  }

  return (
    <>
      <div className='ml-1' style={{ display: 'flex', flexDirection: 'row' }}>
        <Title style={styleTitle}>{title}</Title>
      </div>
      <div className="tw-relative">

        <Input
          {...rest}
          className="uppercase"
          type={type || "text"}
          step={step}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onChange={handleChange}
          style={style}
          value={value}
          mask={mask}
          maxLength={maxLength}
          id={id}
          onBlur={onBlur}
          disabled={disabled}
          
          formatChars={{ '9': '[0-9]', 'a': '[A-Za-z]', '*': '[0-9A-Za-z]' }} // Aceita letras e números após a terceira letra

          {...rest}
        />
      </div>

      {isRequired === false && (
        <span className='text-xs text-[#6E7880] font-normal'>Opcional</span>
      )}

      {touched && error && <Error>{error}</Error>}
    </>
  );
};

export default InputCustom;
